module.exports = __webpack_public_path__ + "img/pro_three_3.560f8d95.jpg";